import { useRef, useEffect } from 'react';

function useLiveRef(value) {
  var ref = useRef(value);
  useEffect(function () {
    ref.current = value;
  });
  return ref;
}

export { useLiveRef };
